import _ from 'lodash'
import { getParams, getState } from './processPortalRules'

export const getValueByUID = (state, uid) => {
  if (!uid || !state) {
    return
  }
  uid = String(uid)
  let group
  if (uid.includes('##')) {
    uid = uid.split('##')
    group = uid[0]
    uid = String(uid[1])
  }
  if (uid.includes(':')) {
    //page field logic || page params logic
    let appState = getState(state)
    return _.get(appState, uid.split(':'), '')
  } else {
    //global params
    let params = getParams(state)
    return _.get(params, uid, '')
  }
}
